/**
 * Pasek ogloszenia nad naglowkiem - napis jedzie w petli, gdy sie nie miesci.
 *
 * Krotki napis zostaje wysrodkowany i nic sie nie rusza. Dluzszy niz szerokosc
 * paska wyjezdza za krawedz, wiec doklejamy druga kopie napisu i przesuwamy caly
 * tor o dlugosc jednej kopii plus przerwe - petla jest wtedy bezszwowa.
 *
 * Predkosc jest STALA (px na sekunde), a nie czas przewiniecia: inaczej dluzszy
 * napis leciałby szybciej i czytalo by sie go gorzej.
 */
(() => {
  /* musi zgadzac sie z `gap` toru w css-critical (.header__announcement-track) */
  const GAP = 80;
  const SPEED = 60; // px / s

  const setup = (paragraph) => {
    const track = paragraph.querySelector('.header__announcement-track');
    const text = track && track.querySelector('.header__announcement-text');
    if (!text) return;

    /* czysty stan przed pomiarem - inaczej mierzylibysmy tor z poprzednia kopia */
    paragraph.classList.remove('is-marquee');
    paragraph.style.removeProperty('--announcement-shift');
    paragraph.style.removeProperty('--announcement-duration');
    track.querySelectorAll('[data-announcement-clone]').forEach((node) => node.remove());

    /* wersja mobilna i desktopowa siedza w dokumencie obie - liczymy tylko widoczna */
    if (!paragraph.offsetParent) return;

    const textWidth = text.getBoundingClientRect().width;
    const room = paragraph.getBoundingClientRect().width;
    if (textWidth <= room + 1) return;

    const clone = text.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.dataset.announcementClone = '';
    track.appendChild(clone);

    const shift = Math.round(textWidth + GAP);
    paragraph.style.setProperty('--announcement-shift', `${shift}px`);
    paragraph.style.setProperty('--announcement-duration', `${(shift / SPEED).toFixed(1)}s`);
    paragraph.classList.add('is-marquee');
  };

  const run = () => document.querySelectorAll('.header__announcement p').forEach(setup);

  const start = () => {
    run();
    /* szerokosc napisu zmienia sie po podmianie fontu z zapasowego na wlasciwy */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  let timer;
  window.addEventListener('resize', () => {
    clearTimeout(timer);
    timer = setTimeout(run, 150);
  });
})();
